import { bless } from "./blessing";
/** @hidden */
export function blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: bless(definition.controllerConstructor)
    };
}
//# sourceMappingURL=definition.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@stimulus/core/dist/definition.js
// module id = null
// module chunks = 